import React, { createContext, useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { firebaseAuth, firestore } from "configurations/firebase";
import { doc, onSnapshot } from "firebase/firestore";
import useAssetsRealtime from "hooks/assets/useAssetsRealtime";

const FirebaseContext = createContext();

const FirebaseProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [auth, setAuth] = useState(null);
  const [systemInfo, setSystemInfo] = useState(null);

  // Commenting out realtime hook since it's not needed
  // useAssetsRealtime();

  useEffect(() => {
    const unsubscribeSystemInfo = onSnapshot(
      doc(firestore, "system", "info"),
      (doc) => {
        if (doc.exists()) {
          setSystemInfo(doc.data());
        } else {
          console.log("System info document does not exist");
          setSystemInfo(null);
        }
      },
      (error) => {
        console.error("Failed to connect to system info:", error);
        setSystemInfo(null);
      }
    );

    return () => {
      unsubscribeSystemInfo();
    };
  }, []);

  return (
    <FirebaseContext.Provider value={{ user, auth, systemInfo }}>
      {children}
    </FirebaseContext.Provider>
  );
};

export { FirebaseContext, FirebaseProvider };
